import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { FulfillmentStatus } from '../api/fulfillmentApi'

const STATUS_CONFIG: Record<FulfillmentStatus, { label: string; className: string }> = {
  DRAFT: { label: 'Draft', className: 'bg-gray-100 text-gray-800 hover:bg-gray-100' },
  SUBMITTED: { label: 'Submitted', className: 'bg-blue-100 text-blue-800 hover:bg-blue-100' },
  IN_PROGRESS: { label: 'In Progress', className: 'bg-indigo-100 text-indigo-800 hover:bg-indigo-100' },
  ON_HOLD: { label: 'On Hold', className: 'bg-amber-100 text-amber-800 hover:bg-amber-100' },
  COMPLETE: { label: 'Complete', className: 'bg-green-100 text-green-800 hover:bg-green-100' },
  CANCELLED: { label: 'Cancelled', className: 'bg-gray-100 text-gray-500 hover:bg-gray-100' },
  ERROR: { label: 'Error', className: 'bg-red-100 text-red-800 hover:bg-red-100' },
}

export function FulfillmentStatusBadge({ status }: { status: FulfillmentStatus }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.DRAFT
  return <Badge variant="secondary" className={cn('font-medium', config.className)}>{config.label}</Badge>
}
